import { Stack } from '@mui/material';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

import GetOrderOption = api.Order.GetOrderOption;

export function PatientOrderFormFields() {
  const { value: orderOption } = useSelectedNodeField<GetOrderOption>('config.getOrderOption');

  return (
    <Stack gap={2}>
      <BlockRadioGroupField
        fieldName="config.getOrderOption"
        label="Options"
        row
        defaultValue={GetOrderOption.GetOneById}
        options={[
          {
            label: 'Get one by order ID',
            value: GetOrderOption.GetOneById,
          },
          {
            label: 'Find all for patient',
            value: GetOrderOption.FindAll,
          },
        ]}
      />
      {orderOption === GetOrderOption.FindAll ? (
        <ParentBlockSelectField
          fieldName="config.patient.sourceBlockName"
          label="Patient Source"
          required
          helperText={getSourceBlockNameHelperText('patient')}
        />
      ) : (
        <BlockValueTemplateField
          fieldName="config.patientOrderId"
          label="Patient Order Id"
          helperText="Enter the reference to the Patient Order Id. e.g. `{{patient.data.patientOrderId}}`"
          placeholder="e.g. {{start.data.patientOrderId}}"
        />
      )}
    </Stack>
  );
}
